<div class="mb-8">
  <lib-breadcrumbs [categoryChain]="categoryChain()" [mainTitle]="article()?.data.title" />

  <h1 class="font-4xl text-center mb-8 text-[--color-text-primary]">{{ article()?.data.title }}</h1>

  <ngx-dynamic-hooks
    class="text-[--color-text-primary]"
    data-source="prismic"
    [content]="articleContent()"
    [options]="{ sanitize: false }"
    [parsers]="checkmarksParser"
  />

  <lib-slices [slices]="slices()" />
</div>
